import { isLocalHost } from "shared/util/EnvironmentHelpers";
import PageState from "legacy/pagestate";

class LocalEnvironment {
	static STORAGE_KEY = "LOCAL_ENVIRONMENT";

	static getEnvironmentUrl() {
		const env = LocalEnvironment.getEnvironment();

		return `https://${env}.okcupid.com`;
	}

	static getEnvironment() {
		// They're not on localhost!
		// Do our best to figure out the current environment anyway.
		if (!isLocalHost) {
			const currentHost = window.location.hostname;

			return currentHost.indexOf(".okcupid.com") >= 0
				? currentHost.replace(".okcupid.com", "")
				: "www";
		}

		// Get previously toggled environment.
		const storedEnv = localStorage.getItem(LocalEnvironment.STORAGE_KEY);

		if (storedEnv) {
			return storedEnv;
		}

		// Use current user's devjail.
		return `${process.env.DEVJAIL_USERNAME}.dev`;
	}

	static setEnvironment(env) {
		localStorage.setItem(LocalEnvironment.STORAGE_KEY, env);

		PageState.clear();
		window.location.reload();
	}
}

export default LocalEnvironment;



// WEBPACK FOOTER //
// ./src/shared/util/LocalEnvironment.js